import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    guestInfo: null,
    mobilekeyInfo: null
  },
  mutations: {
    setMobilekeyInfo (state, data) {
      state.mobilekeyInfo = data
    }
  },
  actions: {
    async getCheckoutStatus ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/checkout`, {
          cmd: 'sc-request-api',
          func: 'get-checkout-status',
          siteid: data.siteid,
          spaceid: data.spaceid,
          key: data.key
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async setCheckout ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/checkout`, {
          cmd: 'sc-request-api',
          func: 'request-mobile-checkout',
          siteid: data.siteid,
          spaceid: data.spaceid,
          key: data.key
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getGuestInfo ({ state }) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.k
      if (siteInfo && ota) {
        try {
          const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
            cmd: 'sc-guest',
            func: 'get-guest-info',
            siteid: siteInfo.site,
            spaceid: siteInfo.space,
            ota: ota
          })
          if (res && res.data && res.data.message) {
            state.guestInfo = res.data.message
          }
          return res.data.message
        } catch (ex) {
          // console.log(ex)
          return ex && ex.response
        }
      }
    },
    async getMorningcall ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-morning-call',
          func: 'get-morning-call-list',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async setMorningcall ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.public ? await store.dispatch('authentication/getOtaKey', true) : siteInfo.k
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-morning-call',
          func: 'set-morning-call',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: ota,
          data: data.data
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async clearMorningcall ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-morning-call',
          func: 'clear-morning-call',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key,
          order_uuid: data.id
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async getParking ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-parking',
          func: 'get-parking-list',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async getMobilityPreset ({ dispatch, state }) {
      const file = 'features/mobility_preset.json'
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`).then(res => {
        return res.data.message
      }).catch((ex) => {
        return false
      })
    },
    async getMobilityOrigin ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-mobility-origin',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k
        })
        return res && res.data && res.data.message ? res.data.message : res.response && res.response.data
      } catch (ex) {
        // console.log(ex)
        console.log(ex)
        return ex && ex.response
      }
    },
    async setParking ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.public ? await store.dispatch('authentication/getOtaKey', true) : siteInfo.k
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-parking',
          func: 'set-parking',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: ota,
          data: data.data
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getMobilityList ({ state }) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-mobility-list',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k
        })
        return res && res.data && res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async setDestination ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'set-destination',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          data: {
            phone: data.phone,
            origin: data.origin,
            destination: data.destination,
            waypoints: data.waypoints
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async getPickup ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-pickup',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            serviceType: data.serviceType,
            origin: data.origin,
            destination: data.destination,
            waypoints: data.waypoints
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getServiceDesc ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-service-desc',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            serviceType: data.serviceType,
            origin: data.origin
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async requestRide ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.public ? await store.dispatch('authentication/getOtaKey', true) : siteInfo.k
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'request-ride',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: ota,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            phone: data.phone,
            serviceType: data.serviceType,
            origin: data.origin,
            destination: data.destination,
            waypoints: data.waypoints,
            serviceToken: data.serviceToken,
            pickupPointToken: data.pickupPointToken
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async requestDestLessRider ({ state }, data) { // 목적지 없는 호출
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'request-dest-less-ride',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            phone: data.phone,
            origin: data.origin
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async cancelRide ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'cancel-ride',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          service: data.service,
          rideId: data.rideId
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getPlace ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const apiKey = 'AIzaSyCg54Eflz1DcKXOCT42M3nYyOLs_SL13Lg'
        const languageCode = router.currentRoute.params.ln
        const res = await axios.post(`https://places.googleapis.com/v1/places:searchText`,
          {
            languageCode: languageCode,
            textQuery: data
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Goog-FieldMask': 'places.id,places.displayName,places.shortFormattedAddress,places.formattedAddress,places.location',
              'X-Goog-Api-Key': apiKey
            }
          })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getMypageInfo ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mypage-info',
          func: 'get-orders-count-ota',
          siteid: siteInfo.site,
          ota: siteInfo.k,
          filter: data
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getMypageHistory ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mypage-info',
          func: 'get-order-history-ota',
          siteid: siteInfo.site,
          ota: siteInfo.k,
          mypageType: data.mypageType,
          ...data.paging && {
            paging: {
              limit: data.paging.limit || 30, // db 검색하는 개수 (리턴개수와 다름)
              ...data.paging.next && {
                next: data.paging.next
              }
            }
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async authMobileKey ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobile-key',
          func: 'auth-mobile-key',
          siteid: siteInfo.site,
          keyOtaId: data.keyOtaId,
          spaceCode: data.spaceCode,
          auth: {
            type: data.authType,
            data: data.authData
          }
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        console.log(ex)
        return ex
      }
    },
    async getMobileKey ({ state, commit }) {
      const authInfo = store.state.authentication
      const spaceCode = authInfo.spaceCode
      const keyOtaId = authInfo.keyOtaId
      const storageItem = `smartkey_${authInfo.site}_${spaceCode}`
      const storage = localStorage.getItem(storageItem)
      const storageData = storage && JSON.parse(storage)
      const spaceid = storageData && storageData.spaceid
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobile-key',
          func: 'get-mobile-key',
          siteid: authInfo.site,
          keyOtaId: keyOtaId,
          spaceCode: spaceCode, // 공간id
          space: spaceid // 객실
        })
        const resMessage = res.data && res.data.message
        const mobileKey = resMessage && resMessage.mobileKey
        const useRemoteOpen = resMessage && resMessage.useRemoteOpen
        const spaceCodeType = resMessage && resMessage.spaceCodeType
        if (mobileKey) {
          commit('setMobilekeyInfo', {
            keyOtaId: keyOtaId,
            spaceCode: spaceCode,
            space: spaceid,
            mobileKey: mobileKey,
            spaceCodeType: spaceCodeType,
            useRemoteOpen: useRemoteOpen
          })
        }
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        // console.log(ex)
        return ex
      }
    },
    async remoteOpenMobileKey ({ state }, data) { // remote open
      const authInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobile-key',
          func: 'remote-open-mobile-key',
          siteid: authInfo.site,
          keyOtaId: data.keyOtaId,
          spaceCode: data.spaceCode,
          space: data.space,
          mobileKey: data.mobileKey
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        // console.log(ex)
        return ex
      }
    },
    async checkInvalidMobileKey ({ state }, data) { // remote open
      const authInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobile-key',
          func: 'check-invalid-mobile-key',
          siteid: authInfo.site,
          keyOtaId: data.keyOtaId,
          spaceCode: data.spaceCode,
          space: data.space,
          mobileKey: data.mobileKey
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        // console.log(ex)
        return ex
      }
    },
  },
  getters: {
    getGuestInfo: state => state.guestInfo,
    getSmartkeyResultData: () => (code) => {
      let result = true
      switch (code) {
        case 210:
          result = 'reauth' // 재인증 요청
          break
        case 301:
          result = 'space' // space 정보가 없는 경우
          break
        case 302:
          result = 'invalid_key_ota_id' // 유효하지 않은 keyOtaId
          break
        case 303:
          result = 'expired_key_ota_id' // 만료된 keyOtaId
          break
        case 351:
          result = 'errors' // request body 포맷 오류 (이 경우 response의 errors를 그대로 출력)
          break
        case 401:
          result = 'invalid_request' // 유효하지 않은 요청 데이터
          break
        case 402:
          result = 'fail_auth' // 인증 실패
          break
        case 403:
          result = 'inactivate' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 410:
          result = 'api_call_failed' // api 호출 결과가 fail
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
        case 501:
          result = 'server_connection_failed' // 서버 연결 실패
          break
      }
      return result
    },
    getMobilekeyInfo: state => state.mobilekeyInfo,
    getUseRemotekey: state => {
      const mobilekeyInfo = state.mobilekeyInfo
      const mobilekey = mobilekeyInfo && mobilekeyInfo.mobileKey
      const useRemoteOpen = mobilekeyInfo && mobilekeyInfo.useRemoteOpen
      return mobilekey && useRemoteOpen
    }
  }
}
